import * as products from './products/ProductsActions';
import * as quantity from './quantity/QuantityActions';
import * as disable from './disable/DisableActions';
import * as deleteActions from './delete/DeleteActions';
import * as multiple from './select-multiple/SelectMultipleActions';
import * as update from './update/UpdateActions';
import * as settings from './settings/SettingsActions';
import * as clear from './clear/ClearActions';
import * as change from './change/ChangeActions';
import * as undoDelete from './undo-delete/UndoDeleteActions';
import * as receiveProductTemplates from './template/TemplateActions';
import * as rename from './rename/RenameActions';
import * as newProduct from './new-product/NewProductActions';

const actions = {
  ...products,
  ...quantity,
  ...deleteActions,
  ...disable,
  ...multiple,
  ...update,
  ...settings,
  ...clear,
  ...undoDelete,
  ...receiveProductTemplates,
  ...rename,
  ...change,
  ...newProduct,
};
export default actions;
